import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import api from '../../../../../components/api';

export const useInvoiceDetail = () => {
  const { clientId, invoiceId } = useParams();

  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery(['invoice-detail', invoiceId], () => api.clients.getClientCoffeeInvoiceDetail(invoiceId!), {
    enabled: !!invoiceId,
  });

  const invoiceData = data?.data?.data;

  return {
    invoiceData,
    isLoading,
    isError,
    error,
  };
};

export default useInvoiceDetail;
